export const defaultState = {
  applealTypes: [],
  appeals: [],
  appeal: null,
  appealDetails: [],
  appealResolved: null,
};
